<template>
  <div class="message">
    <div class="message_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">消息</div>
      <img
        style="width: 17px; height: 19px; position: absolute; right: 30px"
        src="@/assets/mylogin/clear.png"
        alt=""
        @click="setAllRead"
      />
    </div>
    <div class="message_bottom">
      <van-cell-group
        inset
        style="margin: 10px 12px 0px 12px; border-radius: 8px 8px 8px 8px"
      >
        <van-cell @click="isTo()">
          <template #title>
            <van-badge
              :content="unread"
              v-show="unread === 0 ? false : true"
              max="99"
            />
            <img
              style="
                width: 23;
                height: 21px;
                vertical-align: middle;
                margin-right: 10px;
              "
              src="@/assets/mylogin/announcement.png"
              alt=""
            />
            <span style="margin-left: 5px">公告</span>
          </template>
        </van-cell>

        <van-cell @click="isGo()">
          <template #title>
            <van-badge
              :content="sysUnread"
              v-show="sysUnread === 0 ? false : true"
              max="99"
            />
            <img
              style="
                width: 23;
                height: 21px;
                vertical-align: middle;
                margin-right: 10px;
              "
              src="@/assets/mylogin/inform.png"
              alt=""
            />
            <span style="margin-left: 5px">通知</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "setup",
  data() {
    return {
      // 公告未读字段
      unread: 0,
      // 通知未读字段
      sysUnread: 0,
      // 徽标是否展示
      // dot: false
    };
  },
  mounted() {
    this.messageCount();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    isTo() {
      this.$router.push("notice");
    },
    isGo() {
      this.$router.push("tell");
    },
    //消息条数
    async messageCount() {
      let res = await this.$apis.myServe.messageCount();
      this.unread = res.content.announcement.unread;
      this.sysUnread = res.content.sys.sysUnread;
    },
    // 全部标记为已读
    async setAllRead() {
      let res = await this.$apis.myServe.setAllRead();
      if (res.resultCode === "200") {
        this.unread = 0;
        this.sysUnread = 0;
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.message {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .message_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .message_bottom {
    width: 100%;
    height: 100%;
    .van-cell__value {
      position: static;
    }
    .van-badge {
      position: absolute;
      left: 25px;
    }
  }
}
</style>